/**
 * 스플래시 M-1 「담기 · 레드」(Figma Product › 1차 › 스플래시 B안) Canvas 구현. 디자인 전달 패키지 web/hamlak-splash.js 를 옮긴 것.
 * 빈 고양이 실루엣에 빛줄기가 담기며 아래부터 차오르고 → 말랑하게 튕긴 뒤 → 반짝이·워드마크가 뜨는 1.6초. 끝나면 마지막 프레임에서 멈춰 부팅을 기다린다.
 * 고양이는 화면 정중앙 폭 104px 고정(PC에서도 커지지 않음) = Android 시스템 스플래시 splash_cat · iOS LaunchScreen 의 0프레임과 같은 자리.
 */

export const SPLASH_BG = "#d51b34";
const FG = "#ffffff";
export const SPLASH_MOTION_SECONDS = 1.6;
const CAT_PATH = "M30.0228 83.738C31.0226 65.7639 33.0221 41.7984 37.0213 25.8214C38.021 16.8343 45.0195 14.8372 52.018 23.8243L83.0112 56.7768C115.004 44.7941 152.996 44.7941 184.989 56.7768L215.982 23.8243C222.98 14.8372 229.979 16.8343 230.979 25.8214C234.978 41.7984 236.977 65.7639 237.977 83.738C257.973 104.708 259.972 135.663 245.975 158.63C227.979 185.591 192.987 201.568 156.995 238.515C143.998 252.495 124.002 252.495 111.005 238.515C75.0129 201.568 40.0206 185.591 22.0246 158.63C8.02763 135.663 10.0272 104.708 30.0228 83.738ZM108.556 102.286C114.471 102.286 119.267 107.076 119.267 112.983V134.378C119.267 140.285 114.471 145.075 108.556 145.075C102.641 145.075 97.8459 140.285 97.8459 134.378V112.983C97.8459 107.076 102.641 102.286 108.556 102.286ZM159.444 102.286C165.359 102.286 170.154 107.076 170.154 112.983V134.378C170.154 140.285 165.359 145.075 159.444 145.075C153.529 145.075 148.733 140.285 148.733 134.378V112.983C148.733 107.076 153.529 102.286 159.444 102.286Z";
const WORDMARK_PATHS = ["M120.679 25.8223H114.632L110.044 17.6309L107.97 19.793V25.8223H103.048V0H107.97V13.957L114.21 6.75H120.415L113.718 14.0801L120.679 25.8223Z", "M83.7821 8.73633C85.1063 7.04883 87.3798 6.20508 90.6024 6.20508C92.7001 6.20508 94.5634 6.62109 96.1923 7.45312C97.8212 8.28516 98.6356 9.85547 98.6356 12.1641V20.9531C98.6356 21.5625 98.6473 22.3008 98.6708 23.168C98.7059 23.8242 98.8055 24.2695 98.9696 24.5039C99.1337 24.7383 99.3798 24.9316 99.7079 25.084V25.8223H94.2587C94.1063 25.4355 94.0009 25.0723 93.9423 24.7324C93.8837 24.3926 93.8368 24.0059 93.8016 23.5723C93.1102 24.3223 92.3134 24.9609 91.411 25.4883C90.3329 26.1094 89.1141 26.4199 87.7548 26.4199C86.0204 26.4199 84.5848 25.9277 83.4481 24.9434C82.3231 23.9473 81.7606 22.541 81.7606 20.7246C81.7606 18.3691 82.6688 16.6641 84.4852 15.6094C85.4813 15.0352 86.9462 14.625 88.8798 14.3789L90.5848 14.168C91.5106 14.0508 92.1727 13.9043 92.5712 13.7285C93.286 13.4238 93.6434 12.9492 93.6434 12.3047C93.6434 11.5195 93.368 10.9805 92.8173 10.6875C92.2782 10.3828 91.4813 10.2305 90.4266 10.2305C89.243 10.2305 88.4052 10.5234 87.913 11.1094C87.5614 11.543 87.327 12.1289 87.2098 12.8672H82.3759C82.4813 11.1914 82.9501 9.81445 83.7821 8.73633ZM87.5087 22.2012C87.9774 22.5879 88.5516 22.7812 89.2313 22.7812C90.3094 22.7812 91.2997 22.4648 92.202 21.832C93.1161 21.1992 93.5907 20.0449 93.6259 18.3691V16.5059C93.3094 16.7051 92.9872 16.8691 92.6591 16.998C92.3427 17.1152 91.9032 17.2266 91.3407 17.332L90.2157 17.543C89.161 17.7305 88.4052 17.959 87.9481 18.2285C87.1747 18.6855 86.788 19.3945 86.788 20.3555C86.788 21.2109 87.0282 21.8262 87.5087 22.2012Z", "M52.7695 11.9355C52.3477 11.0098 51.5215 10.5469 50.291 10.5469C48.8613 10.5469 47.9004 11.0098 47.4082 11.9355C47.1387 12.4629 47.0039 13.248 47.0039 14.291V25.8223H41.9238V6.69727H46.793V9.49219C47.4141 8.49609 48 7.78711 48.5508 7.36523C49.5234 6.61523 50.7832 6.24023 52.3301 6.24023C53.7949 6.24023 54.9785 6.5625 55.8809 7.20703C56.6074 7.80469 57.1582 8.57227 57.5332 9.50977C58.1895 8.38477 59.0039 7.55859 59.9766 7.03125C61.0078 6.50391 62.1562 6.24023 63.4219 6.24023C64.2656 6.24023 65.0977 6.4043 65.918 6.73242C66.7383 7.06055 67.4824 7.63477 68.1504 8.45508C68.6895 9.12305 69.0527 9.94336 69.2402 10.916C69.3574 11.5605 69.416 12.5039 69.416 13.7461L69.3809 25.8223H64.248V13.623C64.248 12.8965 64.1309 12.2988 63.8965 11.8301C63.4512 10.9395 62.6309 10.4941 61.4355 10.4941C60.0527 10.4941 59.0977 11.0684 58.5703 12.2168C58.3008 12.8262 58.166 13.5586 58.166 14.4141V25.8223H53.1211V14.4141C53.1211 13.2773 53.0039 12.4512 52.7695 11.9355Z", "M22.6934 8.73633C24.0176 7.04883 26.291 6.20508 29.5137 6.20508C31.6113 6.20508 33.4746 6.62109 35.1035 7.45312C36.7324 8.28516 37.5469 9.85547 37.5469 12.1641V20.9531C37.5469 21.5625 37.5586 22.3008 37.582 23.168C37.6172 23.8242 37.7168 24.2695 37.8809 24.5039C38.0449 24.7383 38.291 24.9316 38.6191 25.084V25.8223H33.1699C33.0176 25.4355 32.9121 25.0723 32.8535 24.7324C32.7949 24.3926 32.748 24.0059 32.7129 23.5723C32.0215 24.3223 31.2246 24.9609 30.3223 25.4883C29.2441 26.1094 28.0254 26.4199 26.666 26.4199C24.9316 26.4199 23.4961 25.9277 22.3594 24.9434C21.2344 23.9473 20.6719 22.541 20.6719 20.7246C20.6719 18.3691 21.5801 16.6641 23.3965 15.6094C24.3926 15.0352 25.8574 14.625 27.791 14.3789L29.4961 14.168C30.4219 14.0508 31.084 13.9043 31.4824 13.7285C32.1973 13.4238 32.5547 12.9492 32.5547 12.3047C32.5547 11.5195 32.2793 10.9805 31.7285 10.6875C31.1895 10.3828 30.3926 10.2305 29.3379 10.2305C28.1543 10.2305 27.3164 10.5234 26.8242 11.1094C26.4727 11.543 26.2383 12.1289 26.1211 12.8672H21.2871C21.3926 11.1914 21.8613 9.81445 22.6934 8.73633ZM26.4199 22.2012C26.8887 22.5879 27.4629 22.7812 28.1426 22.7812C29.2207 22.7812 30.2109 22.4648 31.1133 21.832C32.0273 21.1992 32.502 20.0449 32.5371 18.3691V16.5059C32.2207 16.7051 31.8984 16.8691 31.5703 16.998C31.2539 17.1152 30.8145 17.2266 30.252 17.332L29.127 17.543C28.0723 17.7305 27.3164 17.959 26.8594 18.2285C26.0859 18.6855 25.6992 19.3945 25.6992 20.3555C25.6992 21.2109 25.9395 21.8262 26.4199 22.2012Z", "M17.2793 14.5723V25.8223H12.1641V14.168C12.1641 13.1367 11.9883 12.3047 11.6367 11.6719C11.1797 10.7812 10.3125 10.3359 9.03516 10.3359C7.71094 10.3359 6.70312 10.7812 6.01172 11.6719C5.33203 12.5508 4.99219 13.8105 4.99219 15.4512V25.8223H0V0H4.99219V9.1582C5.71875 8.04492 6.55664 7.27148 7.50586 6.83789C8.4668 6.39258 9.47461 6.16992 10.5293 6.16992C11.7129 6.16992 12.7852 6.375 13.7461 6.78516C14.7188 7.19531 15.5156 7.82227 16.1367 8.66602C16.6641 9.38086 16.9863 10.1191 17.1035 10.8809C17.2207 11.6309 17.2793 12.8613 17.2793 14.5723Z", "M73.9863 0H78.9083V25.8223H73.9863V0Z"];

// 기준 좌표계: 고양이 중심 = (0, 0), 단위 px(=pt)
const CAT_SIZE = 104;
const S = CAT_SIZE / 268;
const HEAD_LINE = -CAT_SIZE / 2 + 52 * S; // 빛줄기가 사라지는 머리 윗선 (고양이 중심 기준)
const SILHOUETTE_ALPHA = 0.22;
const T = { fillStart: 0.28, fillDur: 0.5, bounceStart: 0.8, bounceDur: 0.35, sparkleDur: 0.45, wmStart: 0.95, wmDur: 0.4 };
// [x, y(고양이 중심 기준), 크기, 시작 시간]
const SPARKLES: [number, number, number, number][] = [
  [-52 + 236 * S + 10, -52 + 8, 13, 0.95],
  [-52 + 236 * S + 30, -52 + 34, 7, 1.05],
  [-52 + 18 * S - 14, -52 + 14, 8, 1.12],
];

type Streak = { x: number; w: number; len: number; t0: number; v: number; tilt: number };

function makeStreaks(): Streak[] {
  let seed = 11;
  const rnd = () => {
    seed = (seed * 16807) % 2147483647;
    return (seed - 1) / 2147483646;
  };
  return Array.from({ length: 14 }, (_, i) => ({
    x: 172 + rnd() * 46 - 195,
    w: 5 + rnd() * 5,
    len: 70 + rnd() * 120,
    t0: 0.12 + i * 0.032 + rnd() * 0.03,
    v: 1500 + rnd() * 500,
    tilt: (rnd() - 0.5) * 0.12,
  }));
}

const easeOut = (x: number) => (x <= 0 ? 0 : x >= 1 ? 1 : 1 - Math.pow(1 - x, 3));

function roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  r = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function star(ctx: CanvasRenderingContext2D, x: number, y: number, s: number, rot: number) {
  if (s <= 0) return;
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(rot);
  ctx.beginPath();
  ctx.moveTo(0, -s);
  ctx.quadraticCurveTo(s * 0.14, -s * 0.14, s, 0);
  ctx.quadraticCurveTo(s * 0.14, s * 0.14, 0, s);
  ctx.quadraticCurveTo(-s * 0.14, s * 0.14, -s, 0);
  ctx.quadraticCurveTo(-s * 0.14, -s * 0.14, 0, -s);
  ctx.fill();
  ctx.restore();
}

type Shapes = { streaks: Streak[]; cat: Path2D; wordmark: Path2D[] };

/** t초 프레임을 그린다. w,h = CSS px 화면 크기 */
function drawFrame(ctx: CanvasRenderingContext2D, t: number, w: number, h: number, { streaks, cat, wordmark }: Shapes) {
  ctx.fillStyle = SPLASH_BG;
  ctx.fillRect(0, 0, w, h);
  ctx.fillStyle = FG;
  const cx = w / 2;
  const cy = h / 2;
  const startY = -cy - 40; // 화면 맨 위 바로 위에서 출발
  const designStart = -422 - 40; // 390×844 기준 출발점 → 도착 시간을 같게 맞춤

  // 1) 빛줄기 (머리 윗선 위에서만 보임)
  ctx.save();
  ctx.translate(cx, cy);
  ctx.beginPath();
  ctx.rect(-cx, -cy, w, cy + HEAD_LINE + 6);
  ctx.clip();
  for (const k of streaks) {
    const dt = t - k.t0;
    if (dt < 0) continue;
    const v = k.v * ((HEAD_LINE - startY) / (HEAD_LINE - designStart));
    const bottom = startY + v * dt;
    if (bottom - k.len > HEAD_LINE + 6) continue;
    ctx.save();
    ctx.translate(k.x, bottom);
    ctx.rotate(k.tilt);
    roundRect(ctx, -k.w / 2, -k.len, k.w, k.len, k.w / 2);
    ctx.fill();
    ctx.restore();
  }
  ctx.restore();

  // 2) 고양이: 튕김(바닥 가운데 기준) → 빈 실루엣 22% → 아래부터 채움
  const fill = easeOut((t - T.fillStart) / T.fillDur);
  const b = (t - T.bounceStart) / T.bounceDur;
  let sx = 1;
  let sy = 1;
  if (b > 0 && b < 1) {
    const d = Math.sin(b * Math.PI * 2) * (1 - b);
    sy = 1 - d * 0.1;
    sx = 1 + d * 0.07;
  }
  ctx.save();
  ctx.translate(cx, cy + CAT_SIZE / 2);
  ctx.scale(sx, sy);
  ctx.translate(-CAT_SIZE / 2, -CAT_SIZE);
  ctx.scale(S, S);
  ctx.globalAlpha = SILHOUETTE_ALPHA;
  ctx.fill(cat, "evenodd");
  ctx.globalAlpha = 1;
  ctx.save();
  ctx.clip(cat, "evenodd");
  const level = 16 + 233 * (1 - fill);
  const wave = fill > 0 && fill < 1 ? 7 : 0;
  ctx.beginPath();
  ctx.moveTo(0, 268);
  ctx.lineTo(0, level);
  for (let x = 0; x <= 268; x += 12) ctx.lineTo(x, level + Math.sin(x * 0.06 + t * 14) * wave);
  ctx.lineTo(268, 268);
  ctx.closePath();
  ctx.fill();
  ctx.restore();
  ctx.restore();

  // 3) 반짝이 3개
  for (const [x, y, size, start] of SPARKLES) {
    const p = (t - start) / T.sparkleDur;
    if (p < 0 || p > 1) continue;
    const sc = p < 0.35 ? easeOut(p / 0.35) * 1.15 : 1.15 * (1 - easeOut((p - 0.35) / 0.65));
    star(ctx, cx + x, cy + y, size * sc, p * 0.45);
  }

  // 4) 워드마크 (폭 84px, 화면 아래에서 60px)
  const wp = Math.max(0, Math.min(1, (t - T.wmStart) / T.wmDur));
  const we = 1 - Math.pow(1 - wp, 2);
  if (we > 0) {
    const ws = 84 / 121;
    ctx.save();
    ctx.globalAlpha = we;
    ctx.translate(cx - 42, h - 60 - 27 * ws + 8 * (1 - we));
    ctx.scale(ws, ws);
    for (const p of wordmark) ctx.fill(p);
    ctx.restore();
  }
}

/**
 * canvas(부모를 꽉 채운다)에 M-1 을 1회 재생하고 마지막 프레임을 유지한다. prefers-reduced-motion 이면 완성 프레임만.
 * 반환값을 부르면 멈추고 정리한다. Canvas 2D·Path2D 가 없으면(jsdom) 아무것도 그리지 않는다 — 배경색은 CSS 가 칠한다.
 */
export function playSplashMotion(canvas: HTMLCanvasElement): () => void {
  const ctx = typeof Path2D === "undefined" ? null : canvas.getContext("2d");
  if (!ctx) return () => undefined;
  const shapes: Shapes = { streaks: makeStreaks(), cat: new Path2D(CAT_PATH), wordmark: WORDMARK_PATHS.map((d) => new Path2D(d)) };
  const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
  let w = 0;
  let h = 0;
  let t = reduced ? SPLASH_MOTION_SECONDS : 0;
  let raf = 0;

  const fit = () => {
    const dpr = Math.min(3, window.devicePixelRatio || 1);
    w = canvas.clientWidth;
    h = canvas.clientHeight;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  // 크기가 바뀌면 canvas 가 지워지므로 지금 프레임을 다시 그린다(끝난 뒤에도 마지막 프레임 유지)
  const onResize = () => {
    fit();
    drawFrame(ctx, t, w, h, shapes);
  };
  onResize();
  window.addEventListener("resize", onResize);

  if (!reduced) {
    let t0 = 0;
    const tick = (now: number) => {
      if (!t0) t0 = now;
      t = Math.min(SPLASH_MOTION_SECONDS, (now - t0) / 1000);
      drawFrame(ctx, t, w, h, shapes);
      if (t < SPLASH_MOTION_SECONDS) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
  }
  return () => {
    cancelAnimationFrame(raf);
    window.removeEventListener("resize", onResize);
  };
}
